import { Component, OnInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { UsersService, IMultipleDeleteWidgets } from '../../users.service';
import { ActivatedRoute } from '@angular/router';
import { IWidget } from 'src/app/pages/roles/roles.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-widgets-list',
  templateUrl: './widgets-list.component.html',
  styleUrls: ['./widgets-list.component.scss']
})
export class WidgetsListComponent implements OnInit {

  userGuid: string = null;
  loading = false;
  widgets = [];
  selectedWidget: IWidget;
  selectedReportId: number;
  showAddWidgetDialog = false;
  displayedColumns: string[] = ['select', 'name', 'delete'];
  selection = new SelectionModel<IWidget>(true, []);
  url: string;

  constructor(private service: UsersService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.userGuid = this.service.selectedUserId;
    this.selectedReportId = this.route.snapshot.params.reportId;
    this.url = environment.apiUrl;
    this.getWidgets(true);
  }

  getWidgets(refresh: boolean) {
    if (refresh) {
      this.showAddWidgetDialog = false;
      this.service.getWidgetsByDashboardId(this.selectedReportId, this.service.selectedUserId).subscribe(res => {
        this.widgets = res;
      });
    }

  }

  addWidget() {
    this.showAddWidgetDialog = true;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.widgets.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.widgets.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row + 1}`;
  }

  deleteWidgets(selected?: boolean) {
    const isConfirm = confirm('Вы действительно хотите удалить выбранный экран?');
    if (isConfirm) {
      const ids = [];
      if (selected) {
        ids.push(this.selectedWidget.id);
      } else {
        for (let i = 0; i < this.selection.selected.length; i++) {
          ids.push(this.selection.selected[i].id);
        }
      }
      const model: IMultipleDeleteWidgets = {
        ids: ids,
        dashboardId: this.selectedReportId
      };
      this.service.deleteMultipleWidgets(model).subscribe(res => {
        this.getWidgets(true);
        this.selection.clear();
      });
    }
  }


}
